/**
 * Route for `loading-states-skeletons`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { LoadingStatesSkeletonsPage } from "../features/loading-states-skeletons/LoadingStatesSkeletonsPage";

export const loadingStatesSkeletonsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/loading-states-skeletons",
	component: LoadingStatesSkeletonsPage,
});

export default loadingStatesSkeletonsRoute;
